import {
  Type,
  TextLink,
  defaultTheme,
  cssSpacing,
} from '@spotify-internal/encore-web';
import React from 'react';
import { useT } from '@spotify-internal/i18n-core';
import {
  overflowWrapFlexText,
  rootStyle,
  zIndexFixed,
} from '@spotify-internal/encore-web/core/styles';
import styled from 'styled-components';

export const Wrapper = styled.div`
  ${rootStyle()};
  color: var(--text-base, ${defaultTheme.invertedDark.text.base});
  background-color: var(
    --background-base,
    ${defaultTheme.invertedDark.background.base}
  );
  position: fixed;
  inset-block: 0;
  inset-inline-start: 0;
  inline-size: 100%;
  z-index: ${zIndexFixed};
  display: flex;
  flex-direction: column;
  text-align: center;
  overflow: auto;
  ${overflowWrapFlexText()};
`;

const BodyWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  max-inline-size: 100%;
  max-block-size: 100%;
  padding: ${cssSpacing('looser', '24px')};
  margin: auto;

  * {
    margin: auto;
  }
`;

const BodySvg = styled.svg`
  stroke: var(--background-base, ${defaultTheme.invertedDark.background.base});
  margin-block-end: ${cssSpacing('looser-4', '64px')};
  flex-shrink: 0;

  [dir='rtl'] & {
    transform: scaleX(-1);
  }
`;

export const UnsupportedBrowser = () => {
  const translate = useT();
  return (
    <Wrapper data-encore-id="unsupportedBrowser">
      <BodyWrapper>
        <BodySvg role="img" width="214" height="155" aria-hidden="true">
          <rect
            stroke="#FFF"
            strokeWidth="3"
            x="1.5"
            y="1.5"
            width="211"
            height="152"
            rx="9"
          />
          <circle fill="#FFF" cx="16" cy="18" r="4" />
          <circle fill="#FFF" cx="32" cy="18" r="4" />
          <circle fill="#FFF" cx="48" cy="18" r="4" />
          <path
            d="M55 83c3.28 2.667 7.28 4 12 4s8.72-1.333 12-4M135 83c3.28 2.667 7.28 4 12 4s8.72-1.333 12-4"
            stroke="#FFF"
            strokeWidth="3"
            strokeLinecap="square"
          />
          <path
            d="M68 122.374c13-4.25 26-6.374 39-6.374s26 2.125 39 6.374M2.5 34.5h210"
            stroke="#FFF"
            strokeWidth="3"
            strokeLinecap="square"
          />
        </BodySvg>
        <Type as="p" variant="altoBrio" data-testid="unsupported-browser">
          {translate(
            'S4MP_UNSUPPORTED_BROWSER',
            'Your browser doesn’t work with this application',
            'Message to tell the user that their browser is not compatible with s4mp.',
          )}
        </Type>
        <Type as="p" variant="altoBrio">
          <TextLink
            href="https://browser-update.org/update-browser.html"
            standalone
          >
            {translate(
              'S4MP_UPDATE_BROWSER',
              'Switch or update your browser',
              'Link to a page to switch or update to a modern browser',
            )}
          </TextLink>
        </Type>
      </BodyWrapper>
    </Wrapper>
  );
};
